'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { useShallow } from 'zustand/react/shallow';
import { TERM_CATEGORY } from '@/api';
import { useGlobalStore } from '@/stores/GlobalStore';
const BUSINESS_INFO_HREF = 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126';
const POLICY_LINKS = [{
  label: '이용약관',
  onClickType: TERM_CATEGORY.SERVICE_TERMS
}, {
  label: '사용자정보확인',
  href: BUSINESS_INFO_HREF
}, {
  label: '개인정보처리방침',
  onClickType: TERM_CATEGORY.PRIVACY_POLICY,
  className: 'text-B-500'
}, {
  label: '마케팅이용동의',
  onClickType: TERM_CATEGORY.MARKETING_TERMS
}, {
  label: '위치기반서비스 이용약관',
  onClickType: TERM_CATEGORY.LOCATION_POLICY_SELECT
}] as const;
export const SidePolicyLinks = () => {
  const $ = _c(14);
  const [setTermsDrawerType, setIsHomeFooterModalOpen] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== setTermsDrawerType) {
    t0 = POLICY_LINKS.map(link => <li key={link.label}>{"href" in link ? <a href={link.href} target="_blank" rel="noreferrer external" className="font-400 text-Gray-600 typo-caption1">{link.label}</a> : <button type="button" className="font-400 text-Gray-600 typo-caption1" onClick={() => setTermsDrawerType(link.onClickType)}>{link.label}</button>}</li>);
    $[0] = setTermsDrawerType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul className="flex flex-col gap-4">{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-400 text-Gray-600 typo-caption1">ⓒ Wello Inc.</p>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setIsHomeFooterModalOpen) {
    t3 = () => setIsHomeFooterModalOpen(true);
    $[5] = setIsHomeFooterModalOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-600 text-Gray-600 typo-caption2">더보기</span>;
    t5 = <SvgChevronright className="size-10 text-Gray-600" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3) {
    t6 = <div className="mt-12 flex flex-col gap-32 border-t border-Gray-300 py-8"><div className="flex items-center gap-20">{t2}<div className="flex flex-1 justify-end"><button type="button" onClick={t3} className="flex h-26 items-center justify-center gap-4 rounded-xxsmall py-8">{t4}{t5}</button></div></div></div>;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t6) {
    t7 = <section className="mt-32">{t1}{t6}</section>;
    $[11] = t1;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(state) {
  return [state.setTermsDrawerType, state.setIsHomeFooterModalOpen] as const;
}